import {
  IonButton,
  IonChip,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonList,
  IonMenuButton,
  IonPage,
  IonSearchbar,
  IonTitle,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import { AppContext } from "context/app.context";
import { addCircle, trashBin } from "ionicons/icons";
import Footer from "layout/footer";
import { deleteTemplate, getTemplates } from "misc/phqHTTP";
import { MessageTemplate } from "models/message-template.model";
import React, { useContext, useState } from "react";
import "./style.scss";

const Templates = () => {
  const { notifySuccess } = useContext(AppContext);
  const [templates, setTemplates] = useState<MessageTemplate[]>([]);
  const [searchText, setSearchText] = useState("");

  const onDelete = (id: number) => {
    deleteTemplate(id).then((res) => {
      const updatedTemplates = templates.filter(
        (x) => x.MessageTemplateID !== id
      );
      notifySuccess("Template removed");
      setTemplates(updatedTemplates);
    });
  };

  useIonViewWillEnter(() => {
    getTemplates().then((res) => {
      setTemplates(res.data.result);
    });
  })

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary" className="ion-no-border">
          <IonButton fill="clear" slot="start">
            <IonMenuButton menu="adminMenu" color="light"></IonMenuButton>
          </IonButton>
          <IonTitle className="ion-text-center">TEMPLATES</IonTitle>
          <IonButton slot="end" routerLink="/templates/0">
            <IonIcon slot="icon-only" size="large" icon={addCircle}></IonIcon>
          </IonButton>
        </IonToolbar>
        <IonSearchbar
          value={searchText}
          onIonChange={(e) => setSearchText(e.detail.value!)}
        ></IonSearchbar>
      </IonHeader>
      <IonContent>
        <IonList>
          {templates
            .filter((x) =>
              (x.Text + x.Action + x.Domain?.Name).includes(searchText)
            )
            .map((t) => {
              return (
                <IonItemSliding key={t.MessageTemplateID}>
                  <IonItem
                    button
                    routerLink={`/templates/${t.MessageTemplateID}`}
                  >
                    <IonChip disabled className="opacity-5" color="primary">
                      {t.Action}
                    </IonChip>
                    {t.Domain?.Name && (
                      <IonChip disabled className="opacity-5" color="tertiary">
                        {t.Domain.Name}
                      </IonChip>
                    )}
                    <span className="input-text-wrap">{t.Text}</span>
                  </IonItem>
                  <IonItemOptions side="end">
                    <IonItemOption
                      color="danger"
                      onClick={() => onDelete(t.MessageTemplateID!)}
                    >
                      <IonIcon icon={trashBin}></IonIcon>
                    </IonItemOption>
                  </IonItemOptions>
                </IonItemSliding>
              );
            })}
        </IonList>
      </IonContent>
      <Footer />
    </IonPage>
  );
};

export default Templates;
